export const play = {
  id: 'play',
  viewBox: '0 0 512 512',
  svgBody: (
    <g id='XMLID_1429_'>
      <g id='XMLID_194_'>
        <path
          id='XMLID_195_'
          d='M126,206H90c-5.52,0-10,4.48-10,10s4.48,10,10,10h21.78l-23.95,66.62c-1.87,5.2,0.83,10.92,6.03,12.79
			c1.12,0.4,2.26,0.59,3.38,0.59c4.1,0,7.94-2.54,9.41-6.62l28.77-80c1.1-3.06,0.64-6.47-1.23-9.13
			C132.31,207.59,129.26,206,126,206L126,206z'
        />
        <path
          id='XMLID_196_'
          d='M242,206h-36c-5.52,0-10,4.48-10,10s4.48,10,10,10h21.78l-23.95,66.62c-1.87,5.2,0.83,10.92,6.03,12.79
			c1.12,0.4,2.26,0.59,3.38,0.59c4.1,0,7.94-2.54,9.41-6.62l28.77-80c1.1-3.06,0.64-6.47-1.23-9.13
			C248.31,207.59,245.26,206,242,206L242,206z'
        />
        <path
          id='XMLID_197_'
          d='M322,226h21.78l-23.95,66.62c-1.87,5.2,0.83,10.92,6.03,12.79c1.12,0.4,2.26,0.59,3.38,0.59
			c4.1,0,7.94-2.54,9.41-6.62l28.77-80c1.1-3.06,0.64-6.47-1.23-9.13S361.25,206,358,206h-36c-5.52,0-10,4.48-10,10
			S316.48,226,322,226L322,226z'
        />
        <path
          id='XMLID_200_'
          d='M398,162H50c-5.52,0-10,4.48-10,10v168c0,5.52,4.48,10,10,10h348c5.52,0,10-4.48,10-10V172
			C408,166.48,403.52,162,398,162z M60,182h96v148H60V182z M176,182h96v148h-96V182z M388,330h-96V182h96V330z'
        />
        <path
          id='XMLID_1924_'
          d='M512,34c0-18.75-15.25-34-34-34s-34,15.25-34,34c0,15.27,10.12,28.22,24,32.5v158.32
			c0,11.31-8.86,20.56-20,21.25V132c0-5.52-4.48-10-10-10h-36.88C373.23,48.73,302.95,0,224,0S74.77,48.73,46.88,122H10
			c-5.52,0-10,4.48-10,10v248c0,5.52,4.48,10,10,10h30v112c0,5.52,4.48,10,10,10h348c5.52,0,10-4.48,10-10V390h30
			c5.52,0,10-4.48,10-10V266.09c22.17-0.7,40-18.94,40-41.28V66.5C501.88,62.22,512,49.27,512,34z M388,492H60V390h328V492z
			 M428,370H20V142h159c5.52,0,10-4.48,10-10s-4.48-10-10-10H68.47C95.14,60.45,155.97,20,224,20s128.86,40.45,155.53,102H269
			c-5.52,0-10,4.48-10,10c0,5.52,4.48,10,10,10h159L428,370z M478,48c-7.72,0-14-6.28-14-14s6.28-14,14-14s14,6.28,14,14
			S485.72,48,478,48z'
        />
        <path
          id='XMLID_1927_'
          d='M112.33,451h223.33c5.52,0,10-4.48,10-10s-4.48-10-10-10H112.33c-5.52,0-10,4.48-10,10
			S106.81,451,112.33,451z'
        />
        <path
          id='XMLID_1928_'
          d='M224,142c2.63,0,5.21-1.07,7.07-2.93S234,134.63,234,132s-1.07-5.21-2.93-7.07S226.63,122,224,122
			s-5.21,1.07-7.07,2.93S214,129.37,214,132s1.07,5.21,2.93,7.07S221.37,142,224,142z'
        />
      </g>
    </g>
  ),
}
